import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Router } from "./Router";
import useFacebookPixel from "./Common/Hooks/MetaPixelHook";

function App() {
  useFacebookPixel("1029722898668284");
  return (
    <>
      <Router />
      <ToastContainer />
    </>
  );
}

export default App;
